import "./CareerPath.scss";
import { useTranslation } from "react-i18next";
import D3XYCoordinates from "../../components/D3/D3";
import Education from "../Education/Education";
import Skills from "../Skills/Skills";
import Publications from "../Publications/Publications";

const CareerPath = () => {
  const { t } = useTranslation();
  return (
    <section id="career" className="career">
      <h2 className="career__title">
        {t("careerPathTitle1")}
        <span className="career__title--special">{t("careerPathTitle2")}</span>
      </h2>
      <Education />
      <Skills />
      <Publications />
    </section>
  );
};
export default CareerPath;
